import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'patient-layout',
  templateUrl: './patient-layout.component.html',
  styleUrls: [],
})
export class PatientLayoutComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
